import { useRouter } from 'next/router';

import {
  getNavScreen,
  getOwnershipListHref,
  resolveMenuHref,
} from '../utils/navPath';

import { useNavigationPath } from './useNavigationPath';
import { useResolvedOwnership } from './useResolvedOwnership';

/**
 * 좌측 메뉴 선택에 쓸 href. 메뉴 아래 화면이면 길의 맨 왼쪽 메뉴, 없으면 소유 기준 메뉴.
 * 소유를 모르는 동안은 아무것도 고르지 않는다(`''`).
 */
export function useActiveMenuHref() {
  const { pathname } = useRouter();
  const { path } = useNavigationPath();
  const isMine = useResolvedOwnership();

  const screen = getNavScreen(pathname);
  if (!screen || screen.depth === 0) return pathname;
  return resolveMenuHref(
    path,
    isMine === null ? null : getOwnershipListHref(isMine),
  );
}
